<section class="w-full">
    @for (ref of references(); track $index) {
        @let unavailableLabel = ref | apply: getReferenceUnavailableLabel;
        <div
            class="flex w-full overflow-hidden rounded-8 bg-surface-B"
            [ngClass]="{
                'mb-8': !$last,
            }"
        >
            <button
                class="relative flex min-w-0 grow gap-x-8 text-left after:absolute after:inset-0 after:content-[''] hover:after:bg-hovered-layer active:after:bg-pressed-layer"
                type="button"
                (click)="openRefPreview(ref)"
            >
                @if (ref.type === AISharedReferenceType.POST) {
                    @if (
                        ref.post
                            | apply: getCustomPostPreviewImage
                            | storageTemporaryLink$
                            | async;
                        as previewImg
                    ) {
                        <interacta-image
                            class="size-72 shrink-0 overflow-hidden rounded-8"
                            [alt]="
                                ref.post.coverImage
                                    ? ('POST_CREATE.COVER' | translate)
                                    : ref.post.mainAttachment?.name
                            "
                            [classes]="'object-cover size-full'"
                            [src]="previewImg"
                        />
                    } @else {
                        <div
                            class="flex size-72 shrink-0 items-center justify-center rounded-8"
                            [ngStyle]="{
                                background:
                                    ref.post.id
                                    | apply: getRandomSecondaryColorVariables,
                            }"
                        >
                            <interacta-image
                                alt=""
                                class="size-60"
                                [src]="'assets/shared/images/pro-tip/post.png'"
                            />
                        </div>
                    }
                }

                @if (ref.type === AISharedReferenceType.ATTACHMENT) {
                    @let attachment = ref.attachment.attachmentData;
                    @if (
                        attachment
                            | apply: getAttachmentPreviewImageLink
                            | storageTemporaryLink$
                            | async;
                        as previewImg
                    ) {
                        <span class="relative size-72 shrink-0">
                            <interacta-image
                                alt=""
                                class="block size-full overflow-hidden rounded-8"
                                [classes]="'object-cover size-full'"
                                [src]="previewImg"
                            />
                            <interacta-attachment-icon
                                class="absolute top-4 left-4"
                                [attachment]="attachment"
                            />
                        </span>
                    } @else {
                        <span
                            class="flex size-72 shrink-0 items-center justify-center rounded-8"
                            [class]="attachment.iconColor ?? 'bg-filetype-docs'"
                        >
                            <interacta-image
                                alt=""
                                [classes]="'size-48 rounded-4'"
                                [src]="attachment.iconPath || ''"
                            />
                        </span>
                    }
                }

                @if (ref.type === AISharedReferenceType.COMMENT) {
                    <div
                        class="flex size-72 shrink-0 items-center justify-center rounded-8 bg-status-H"
                    >
                        <interacta-image
                            alt=""
                            class="size-60"
                            [src]="'assets/images-2.0/tabs/comments.png'"
                        />
                    </div>
                }

                <div
                    class="flex flex-col justify-center gap-4 overflow-hidden py-4 pr-8"
                >
                    <p
                        class="line-clamp-2 typo-sm-bold wrap-break-word"
                        [class.text-text-mid-contrast]="!!unavailableLabel"
                    >
                        {{ ref | apply: getReferenceTitle }}
                    </p>
                    @if (unavailableLabel) {
                        <interacta-badge
                            class="h-18! self-start px-4! typo-xs-bold text-text-on-status"
                            [bgColor]="'status-J'"
                            [rounded]="'small'"
                        >
                            {{ unavailableLabel | translate }}
                        </interacta-badge>
                    } @else if (
                        ref | apply: getReferencePreviewText;
                        as previewText
                    ) {
                        <p class="line-clamp-1 typo-xs text-text-mid-contrast">
                            {{ previewText }}
                        </p>
                    }
                </div>
            </button>
            @if (ref.canView) {
                <div
                    class="flex shrink-0 flex-col justify-center gap-y-4 bg-surface-100 px-4"
                >
                    <button
                        data-testid="ai-reference-ask"
                        interacta-icon-button
                        type="button"
                        [icon]="'reply'"
                        [label]="'AI.ASK_SOURCE' | translate"
                        [size]="'small'"
                        [style]="'text'"
                        [tooltipPosition]="'above'"
                        (click)="askReference.emit(ref)"
                    ></button>
                    <button
                        #smartActionsBtn="cdkOverlayOrigin"
                        aria-haspopup="menu"
                        cdkOverlayOrigin
                        data-testid="ai-reference-smart-actions"
                        interacta-icon-button
                        type="button"
                        [attr.aria-controls]="
                            openedSmartActions() === $index
                                ? smartActionsMenuId
                                : null
                        "
                        [attr.aria-expanded]="openedSmartActions() === $index"
                        [disabled]="smartActionsDisabled()"
                        [icon]="'ellipsis-vertical'"
                        [label]="'AI.SMART_ACTIONS' | translate"
                        [size]="'small'"
                        [style]="'text'"
                        [tooltipPosition]="'below'"
                        (click)="openedSmartActions.set($index)"
                    ></button>
                    <interacta-menu
                        [id]="smartActionsMenuId"
                        [open]="openedSmartActions() === $index"
                        [origin]="smartActionsBtn"
                        (closing)="openedSmartActions.set(null)"
                    >
                        @for (
                            action of smartActions[ref.type];
                            track action.id
                        ) {
                            <button
                                interactaMenuItemDecorator
                                type="button"
                                (click)="emitSmartAction(ref, action)"
                            >
                                <interacta-icon
                                    class="size-24"
                                    [icon]="action.icon"
                                />
                                <p>{{ action.label | translate }}</p>
                            </button>
                        }
                    </interacta-menu>
                </div>
            }
        </div>
    }
</section>
